<template>
<div>
<label class="switch">
  <input type="checkbox" :disabled="!isEditable" v-model="checked" />
  <span :class="getSliderCSS"></span>
</label>
</div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked: {
      get () {
        return this.value
      },
      set (value) {
        if (this.isEditable) {
          this.$emit('input', value)
        }
      }
    },
    getSliderCSS () {
      if (!this.isEditable) {
        return 'slider round nocursor'
      } else {
        return 'slider round'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~@/styles/defaults.scss';

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input { display:none; }

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: $brand-primary;
}

input:focus + .slider {
  box-shadow: 0 0 1px $brand-primary;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.nocursor {
  cursor: default;
}

</style>



// WEBPACK FOOTER //
// src/components/toggle.vue